import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const ProgressBars = ({ progress: { skill, level } }) => {
    return (
        <Fragment>
            <h3>{skill}</h3>
            <div className="progress"><div style={{ 'width': `${level}` }}></div></div>
        </Fragment>
    )
}

ProgressBars.propTypes = {
    skill: PropTypes.object.isRequired,
}

export default ProgressBars
